import { render, staticRenderFns } from "./residentElderly.vue?vue&type=template&id=666b7650&scoped=true"
import script from "./residentElderly.vue?vue&type=script&lang=js"
export * from "./residentElderly.vue?vue&type=script&lang=js"
import style0 from "./residentElderly.vue?vue&type=style&index=0&id=666b7650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666b7650",
  null
  
)

export default component.exports